<template>
  <Layout>
    <template #header> EMB动态特性 </template>
    <div class="row q-col-gutter-x-md full-height">
      <div class="col-5 column justify-around">
        <q-card bordered class="full-height column">
          <!-- <div class="row justify-between">
            <q-toggle
              @update:model-value="handleToggleChange"
              v-model="switching"
              checked-icon="check"
              color="green"
              unchecked-icon="clear"
              size="lg"
            >
            </q-toggle>
          </div> -->
          <!-- <q-card-section
            class="column justify-center items-center q-pb-none  q-col-gutter-y-md"
          > -->
          <!-- <div class="text-h5" style="font-weight: bold; margin-top: 10px">
           
            </div> -->
          <!-- <q-btn-toggle
              style="margin-top: 30px"
              size="md"
              glossy
              rounded
              unelevated
              @update:model-value="handleBtnToggleChange"
              v-model="btnToggle"
              toggle-color="green-10"
              :options="btnToggleOptions"
              :disable="!switching || playStatus === 'play'"
            /> -->
          <!-- </q-card-section> -->

          <q-card-section class="column items-center q-pb-none" style="flex: 1">
            <div class="text-h6 text-weight-bold">
              活塞位置 {{ notifyData.UIRx_BrakeAirGap }} mm
            </div>
            <!-- <Caliper :value="btnToggle" /> -->
            <Caliper2 :value="notifyData.UIRx_BrakeAirGap" class="q-pt-md" />
          </q-card-section>
          <q-card-section class="column items-center q-pb-none" style="flex: 1">
            <CaliperGauge
              :value="notifyData.UIRx_BrakeAirGap || 0"
              class="absolute"
              style="left: 40%; top: -53px"
            />
          </q-card-section>
        </q-card>
      </div>
      <div class="col-7 column q-col-gutter-y-md">
        <div style="flex: 1">
          <q-card bordered class="column full-height">
            <q-card-section class="q-pa-none" style="flex: 1">
              <div class="full-height column">
                <div style="flex: 1">
                  <div
                    class="absolute text-weight-bold text-h6"
                    v-show="showTTL"
                    style="left: 60px; top: 30px; z-index: 9"
                  >
                    TTL时间: {{ TTL || 0 }} ms
                  </div>

                  <DomainControlCharts
                    ref="chartRef1"
                    :max="20000"
                    :min="0"
                    :series="options1"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom"
                    :data-zomm-mirror-drag="false"
                    @data-zoom="(value) => handleDataZoom(value, 1)"
                    :showXAxisLabel="false"
                  />
                </div>
                <div class="overflow-hidden" style="flex: 1">
                  <DomainControlCharts
                    ref="chartRef2"
                    :max="150"
                    :min="0"
                    :series="options2"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom2"
                    :data-zomm-mirror-drag="false"
                    @data-zoom="(value) => handleDataZoom(value, 2)"
                    :showXAxisLabel="true"
                  />
                </div>
                <!-- <div class="overflow-hidden" style="flex: 1">
                  <DomainControlCharts
                    ref="chartRefSmall"
                    :title="titleSmall"
                    :max="3000"
                    :min="0"
                    :series="optionsSmall"
                    :grid="grid"
                    :x-axis-length="LENGTH"
                    x-axis-name="sec"
                    :dataZoom="dataZoom"
                    :data-zomm-mirror-drag="false"
                  />
                </div> -->
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref, watch } from "vue";
import {
  decreasingSequence,
  getXaxis,
  getDefaultSeriesData,
  getGrid,
  LENGTH,
  optionseries1,
  PlayStatus,
  btnToggleOptions,
  getTooltip,
  getDataZoom,
  getTitle,
  preDecreasingSequence,
  parseUIRx_BrkPdlPositionAct,
  parseUIRx_WhlBrkTqAct_FL_BCh1,
  optionseries2,
  parseUIRx_DrvrReqTrgtFxBrk_Bch1,
  getDataZoom2,
  parseUIRx_BrakeAirGap,
} from "./helper/ada";
import Layout from "./components/Layout.vue";
import useInitialize from "@/composables/domainControl/useInitialize";
import { SERVICE } from "@/services/domainControl/define";
import { NOTIFY } from "@/services/domainControl/ada";
import { useQuasar } from "quasar";
import { useDomainControlStore } from "@/stores/domainControl";
import Caliper from "./components/ADA/Caliper.vue";
import Caliper2 from "./components/ADA/Caliper2.vue";
import DomainControlCharts from "@/components/DomainControlCharts";
import CaliperGauge from "./components/ADA/CaliperGauge";

const $q = useQuasar();
const domainControlStore = useDomainControlStore();
const xAxis = getXaxis();
const titleOption = getTitle();
const grid = getGrid();
const tooltip = getTooltip();
const dataZoom = getDataZoom();
const dataZoom2 = getDataZoom2();
const titleBig = { text: "大间隙", ...titleOption };
const titleMiddle = { text: "中间隙", ...titleOption };
const titleSmall = { text: "小间隙", ...titleOption };

const switching = ref(false);
const btnToggle = ref(0);

const seriesData = ref(getDefaultSeriesData());
const options1 = ref(optionseries1());
const options2 = ref(optionseries2());
const showTTL = ref(false);
const TTL = ref(0);

const chartRef1 = ref<InstanceType<typeof DomainControlCharts>>();
const chartRef2 = ref<InstanceType<typeof DomainControlCharts>>();

const playStatus = ref<PlayStatus>("pause");
const notifyData = reactive({
  UIRx_BrakeAirGap: 0,
} as Partial<DomianControl.ADANotifyData>);

let perSeriesData = getDefaultSeriesData();

watch(
  () => seriesData.value,
  (newValue) => {
    const {
      UIRx_DrvrReqTrgtFxBrk_Bch1,
      UIRx_FLWhlSpd_BCh1,
      UIRx_FRWhlSpd_BCh1,
      UIRx_RLWhlSpd_BCh1,
      UIRx_RRWhlSpd_BCh1,

      UIRx_VehSpd,
      UIRx_WhlBrkTqAct_FL_BCh1,
      UIRx_WhlBrkTqAct_FR_BCh1,
      UIRx_WhlBrkTqAct_RL_BCh1,
      UIRx_WhlBrkTqAct_RR_BCh1,
    } = newValue;

    (options1?.value as any)[0].data = UIRx_DrvrReqTrgtFxBrk_Bch1;
    (options1?.value as any)[1].data = UIRx_WhlBrkTqAct_FL_BCh1;
    (options1?.value as any)[2].data = UIRx_WhlBrkTqAct_FR_BCh1;
    (options1?.value as any)[3].data = UIRx_WhlBrkTqAct_RL_BCh1;
    (options1?.value as any)[4].data = UIRx_WhlBrkTqAct_RR_BCh1;

    (options2?.value as any)[0].data = UIRx_VehSpd;
    (options2?.value as any)[1].data = UIRx_FLWhlSpd_BCh1;
    (options2?.value as any)[2].data = UIRx_FRWhlSpd_BCh1;
    (options2?.value as any)[3].data = UIRx_RLWhlSpd_BCh1;
    (options2?.value as any)[4].data = UIRx_RRWhlSpd_BCh1;
  },
  { deep: true }
);

const parseData = async (data: DomianControl.ADANotifyData) => {
  // 开始：检测到踏板开度数值大于4.5%时（即识别踏板开度小于4.5%到大于4.5%的上升沿）开始绘
  if (
    notifyData.UIRx_BrkPdlPositionAct !== undefined &&
    notifyData.UIRx_BrkPdlPositionAct <= 4.5
  ) {
    // 制动踏板开度信号>4.5且参考车速信号>=20kph
    if (data.UIRx_BrkPdlPositionAct > 4.5 && data.UIRx_VehSpd >= 20) {
      await handlePlayStatusChange("play");
    }
  }
  const newData = {} as any;
  Object.keys(data).forEach((key) => {
    let value = data[key];
    if (key === "UIRx_BrakeAirGap") {
      value = parseUIRx_BrakeAirGap(value);
    }
    if (key === "UIRx_DrvrReqTrgtFxBrk_Bch1") {
      value = parseUIRx_DrvrReqTrgtFxBrk_Bch1(value);
    }
    notifyData[key] = value;
    newData[key] = value;
  });
  // update 前置 250 ms 数据
  const keys = getkeysByBtnToggle();
  keys.map((key) => {
    let value = newData[key];
    // 前置 250 ms 数据
    const perList = perSeriesData[key] || [];
    perList.push(value);
    if (perList.length >= preDecreasingSequence.length) perList.shift();
    perSeriesData[key] = perList;
  });
  return newData;
};

const handleNotify = async (data: DomianControl.ADANotifyData) => {
  const newData = await parseData(data);
  // 开关开启 && palying
  if (playStatus.value === "play") parseSeriesData(newData);
};

const getkeysByBtnToggle = () => {
  let keys = [
    "UIRx_DrvrReqTrgtFxBrk_Bch1",
    "UIRx_FLWhlSpd_BCh1",
    "UIRx_FRWhlSpd_BCh1",
    "UIRx_RLWhlSpd_BCh1",
    "UIRx_RRWhlSpd_BCh1",
    "UIRx_VehSpd",
    "UIRx_WhlBrkTqAct_FL_BCh1",
    "UIRx_WhlBrkTqAct_FR_BCh1",
    "UIRx_WhlBrkTqAct_RL_BCh1",
    "UIRx_WhlBrkTqAct_RR_BCh1",
  ] as string[];

  return keys;
};
const setChartsDataZoom = (type: PlayStatus) => {
  let dataZoom = [{ startValue: 0, endValue: 200 }, {}];
  if (type === "pause") {
    dataZoom = [{ startValue: 0, endValue: 20 }, {}];
  } else {
    dataZoom = [{ startValue: 0, endValue: 200 }, {}];
  }
  chartRef1.value?.echarts?.setOption({
    dataZoom: dataZoom,
  });
  chartRef2.value?.echarts?.setOption({
    dataZoom: dataZoom,
  });
};

const handleDataZoom = (value: any, key = 1) => {
  const { end, start, dataZoomId } = value;
  if (dataZoomId === "dataZoomY") {
    const dataZoom = [{}, { end, start: 0 }];
    if (key === 1) {
      chartRef1.value?.echarts?.setOption({
        dataZoom: dataZoom,
      });
    } else {
      chartRef2.value?.echarts?.setOption({
        dataZoom: dataZoom,
      });
    }
  }
  if (dataZoomId === "dataZoomX") {
    const dataZoom = [{ end, start }, {}];
    chartRef1.value?.echarts?.setOption({
      dataZoom: dataZoom,
    });
    chartRef2.value?.echarts?.setOption({
      dataZoom: dataZoom,
    });
  }
};

const parseSeriesData = (data: DomianControl.ADANotifyData) => {
  if (data.UIRx_TTL < 200 && data.UIRx_TTL > 50) {
    TTL.value = data.UIRx_TTL;
    showTTL.value = true;
  }
  const keys = getkeysByBtnToggle();
  keys.map((key) => {
    let value = data[key];
    const curList = (seriesData.value as any)[key] || [];
    // 驾驶员目标制动力
    // if (key === "UIRx_DrvrReqTrgtFxBrk_Bch1") {
    // const perXAxis = (options1?.value as any)[0].markLine.data[0].xAxis;
    // // UIRx_DrvrReqTrgtFxBrk_Bch1 驾驶员目标制动力DrvrReqTrgtFxBrk（单位换算后的值）大于50Nm处画一条虚线
    // if (value > 50 && perXAxis === -1) {
    //   // const xAxis = (decreasingSequence[curList.length] || 0).toString();
    //   (options1?.value as any)[0].markLine.data[0] = {
    //     xAxis: curList.length || 0,
    //   };
    // }
    // }
    // FL的实际制动扭
    // if (key.includes("UIRx_WhlBrkTqAct_FL_BCh1")) {
    // const perXAxis = (options1?.value as any)[0].markLine.data[1].xAxis;
    // // UIRx_WhlBrkTqAct_FL_BCh1 FL的实际制动扭矩达到2600Nm处画一条虚线
    // if (value > 2600 && perXAxis === -1) {
    //   // const xAxis = (decreasingSequence[curList.length] || 0).toString();
    //   (options1?.value as any)[0].markLine.data[1] = {
    //     xAxis: curList.length || 0,
    //   };
    // }
    // }
    if (curList.length >= decreasingSequence.length) {
      // LENGTH s 后停止绘图
      handlePlayStatusChange("pause");
      return;
    }
    curList.push(value);
    (seriesData.value as any)[key] = curList;
  });
};
const resetSeriesDataByBtnToggle = () => {
  showTTL.value = false; // 重置 showTTL
  // 重置 seriesData 使用 perSeriesData
  const keys = getkeysByBtnToggle();
  keys.map((key) => {
    const perList = perSeriesData[key] || [];
    (seriesData.value as any)[key] = [...perList];
  });
  // 重置虚线
  // (options1?.value as any)[0].markLine.data[0] = { xAxis: -1 };
  // (options1?.value as any)[0].markLine.data[1] = { xAxis: -1 };
};

const handlePlayStatusChange = async (value: PlayStatus) => {
  setChartsDataZoom(value);
  if (value === "play") {
    resetSeriesDataByBtnToggle();
    if (!isNotifyed.value) {
      $q.loading.show();
      await startNotifications().finally(() => $q.loading.hide());
    }
  }
  playStatus.value = value;
};
const parseOutputValue = (value: DomianControl.OutputValue) => {
  const { UITx_AdaDrvrCtrlSt } = value;
  switching.value = UITx_AdaDrvrCtrlSt === 0 ? false : true;
  btnToggle.value = UITx_AdaDrvrCtrlSt;
};

const { startNotifications, isNotifyed } = useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

onMounted(() => {
  // setInterval(() => {
  //   handleNotify(generateMockADANofifyData() as any);
  // }, 50);
});
</script>

<style scoped lang="scss">
.car-img {
  :deep(.q-img__content) > div {
    background-color: transparent;
    padding: 0;
  }
}
.q-img {
  overflow: unset;
}

:deep(.q-btn-group .q-btn) {
  padding: 0px 38px !important;
}

:deep(.q-btn-group .q-btn:not(:first-of-type)) {
  // border-left: 1px solid #ccc;
}
.title7 {
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    width: 230px;
    height: 100%;
    opacity: 0.7;
    // background: linear-gradient(to left,
    //         #fff,
    //         #4bf15900);
  }

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    position: absolute;
    height: 2px;
    width: 100%;
    background: linear-gradient(to right, #6c727a, rgba(255, 255, 255, 0));
  }
}
</style>
